<template>
  <svg
    id="polygon-icon"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0.5 0.5 17.25 17.25"
  ><path
    class="polygon-inner-fill"
    d="M13.35,5.48c-.41-.02-.8-.13-1.16-.35-.49-.3-.84-.76-1.03-1.29l-5.67,.81c-.02,.41-.14,.8-.35,1.16-.3,.49-.76,.84-1.29,1.03l.81,5.67c.41,.02,.8,.14,1.16,.35,.49,.3,.84,.76,1.03,1.29l5.67-.81c.02-.41,.14-.8,.35-1.16,.3-.49,.76-.84,1.29-1.03l-.81-5.68Z"
  /><path
    class="polygon-stroke"
    d="M17.43,12.92c-.15-.65-.55-1.2-1.12-1.55-.36-.22-.75-.33-1.16-.35l-.81-5.67c.53-.19,.99-.54,1.29-1.03,.35-.57,.46-1.24,.3-1.89s-.55-1.2-1.12-1.55c-.57-.35-1.24-.46-1.89-.3-.65,.15-1.2,.55-1.55,1.12-.22,.36-.33,.75-.35,1.16l-5.67,.81c-.19-.53-.54-.99-1.03-1.29-.57-.35-1.24-.46-1.89-.3-.65,.15-1.2,.55-1.55,1.12-.35,.57-.46,1.24-.3,1.89s.55,1.2,1.12,1.55c.36,.22,.75,.33,1.16,.35l.81,5.68c-.53,.19-.99,.54-1.29,1.03-.35,.57-.46,1.24-.3,1.89s.55,1.2,1.12,1.55c.4,.25,.85,.37,1.3,.37,.19,0,.39-.02,.58-.07,.65-.15,1.2-.55,1.55-1.12,.22-.36,.33-.75,.35-1.16l5.67-.81c.19,.53,.54,.99,1.03,1.29,.4,.25,.85,.37,1.3,.37,.19,0,.39-.02,.58-.07,.65-.15,1.2-.55,1.55-1.12,.35-.57,.46-1.24,.3-1.89ZM13.5,1.5c.83,0,1.5,.67,1.5,1.5s-.67,1.5-1.5,1.5-1.5-.67-1.5-1.5,.67-1.5,1.5-1.5ZM3,6c-.83,0-1.5-.67-1.5-1.5s.67-1.5,1.5-1.5,1.5,.67,1.5,1.5-.67,1.5-1.5,1.5Zm1.5,10.5c-.83,0-1.5-.67-1.5-1.5s.67-1.5,1.5-1.5,1.5,.67,1.5,1.5-.67,1.5-1.5,1.5Zm8.37-4.31c-.22,.36-.33,.75-.35,1.16l-5.67,.81c-.19-.53-.54-.99-1.03-1.29-.36-.22-.75-.33-1.16-.35l-.81-5.67c.53-.19,.99-.54,1.29-1.03,.22-.36,.33-.75,.35-1.16l5.67-.81c.19,.53,.54,.99,1.03,1.29,.36,.22,.75,.33,1.16,.35l.81,5.68c-.53,.19-.99,.54-1.29,1.03Zm2.13,2.81c-.83,0-1.5-.67-1.5-1.5s.67-1.5,1.5-1.5,1.5,.67,1.5,1.5-.67,1.5-1.5,1.5Z"
  /></svg>
</template>

<script>
export default {
  name: 'PolygonIcon',
};
</script>

<style scoped lang="scss">
.polygon-inner-fill {
  stroke-width: 1px;
  stroke: var(--feature-color, main.$npGray);
  fill: var(--feature-color, main.$npGray);
  opacity: 50%;
}
.polygon-stroke {
  fill: var(--feature-color, main.$npGray);
}
// eslint-disable-next-line vue-scoped-css/no-unused-selector -- used in parent component
.disabled {
  .polygon-inner-fill {
    fill: darkgrey;
    stroke: darkgrey;
  }
  .polygon-stroke {
    fill: darkgrey;
  }
}
// eslint-disable-next-line vue-scoped-css/no-unused-selector -- used in parent component
.selected {
  .polygon-stroke {
    fill: #fff;
  }
}
</style>

